import { STAGE_META, STAGE_ORDER } from '../constants/Stages.js';

export function canTransitionStage(fromStage, toStage) {
    if (!fromStage || !toStage || fromStage === toStage) {
        return { allowed: false, message: 'Invalid stage transition.' };
    }
    return { allowed: true };
}

export function canTransitionStageKanban(fromStage, toStage) {
    if (!fromStage || !toStage || fromStage === toStage) {
        return { allowed: false, message: 'Invalid stage transition.' };
    }
    return { allowed: true };
}

export function stageForProbability(probability) {
    const prob = Number(probability);
    if (Number.isNaN(prob)) return null;

    for (const key of STAGE_ORDER) {
        const meta = STAGE_META[key];
        if (prob >= meta.probabilityMin && prob <= meta.probabilityMax) {
            return key;
        }
    }
    return STAGE_ORDER[STAGE_ORDER.length - 1] ?? null;
}

export function defaultProbabilityForStage(stage) {
    return STAGE_META[stage]?.probabilityMin ?? null;
}
